const initialState = { access : false }

export default function sessionReducer(state = initialState) {
    return state;
}